module.exports = __webpack_public_path__ + "img/hero_featurecards.d5b474cd.png";